import { createStore, createEvent, createEffect, sample } from 'effector';
import { disableTelegramLogs } from '../utils/telegramLogger';
import { TELEGRAM_CONFIG } from '../config/telegramConfig';

// События
export const initializeTelegram = createEvent();
export const setTelegramStatus = createEvent<string>();
export const setStartParam = createEvent<string>();

// Эффекты
export const initializeTelegramFx = createEffect(() => {
  console.log('initializeTelegramFx started');
  return new Promise<void>((resolve, reject) => {
    if (window.Telegram?.WebApp?.initDataUnsafe) {
      try {
        // Инициализация
        window.Telegram.WebApp.ready();
        window.Telegram.WebApp.expand();
        window.Telegram.WebApp.lockOrientation();
        // Отключаем внутренние логи Telegram Web App (если настроено)
        if (TELEGRAM_CONFIG.disableTelegramLogs) {
          disableTelegramLogs();
        }
        
        // Настройки интерфейса управляются через Telegram Web App API
        
        // MainButton управляется через mainButtonStore        
        console.log('Telegram Web App initialized successfully');
        resolve();
      } catch (error) {
        reject(new Error(`Ошибка инициализации Telegram Web App: ${error}`));
      }
    } else {
      reject(new Error('Telegram Web App недоступен'));
    }
  });
});

// Тип состояния
export interface TelegramState {
  isInitialized: boolean;
  initData?: string;
  startParam?: string;
  status: string;
  error: string | null;
}

// Store
export const telegramStore = createStore<TelegramState>({
  isInitialized: false,
  status: 'Инициализация...',
  error: null,
})
  .on(initializeTelegramFx.pending, (state, pending) => {
    console.log('Telegram Web App initialization pending:', pending, 'current state:', state);
    // Не перезаписываем статус, если уже инициализировано
    if (state.isInitialized && !pending) {
      return state;
    }
    return { 
      ...state, 
      status: pending ? 'Инициализация Telegram Web App...' : state.status,
      error: null 
    };
  })
  .on(initializeTelegramFx.done, (state) => {
    console.log('Telegram Web App initialization done');
    // Защита от повторной инициализации
    if (state.isInitialized) {
      console.log('Telegram Web App already initialized, skipping state update');
      return state;
    }
    const newState = { 
      ...state, 
      isInitialized: true,
      status: 'Telegram Web App инициализирован'
    };
    console.log('New telegram state (done):', newState);
    return newState;
  })
  .on(initializeTelegramFx.fail, (state, { error }) => {
    console.error('Telegram Web App initialization failed:', error);
    return { 
      ...state, 
      error: error.message,
      status: `Ошибка инициализации: ${error.message}`
    };
  })
  .on(setTelegramStatus, (state, status) => ({ ...state, status }))
  .on(setStartParam, (state, startParam) => ({ ...state, startParam }));

// Связываем событие с эффектом
sample({
  clock: initializeTelegram,
  target: initializeTelegramFx,
});

// Actions
export const initTelegram = initializeTelegram;
